import React, { FunctionComponent } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { commonStyles, useSafeIntl } from 'bluesquare-components';
import { defineMessages } from 'react-intl';

const useStyles = makeStyles(theme => ({
    ...commonStyles(theme),
}));

const MESSAGES = defineMessages({
    search: {
        defaultMessage: 'Search',
        id: 'iaso.search',
    },
});

type Props = {
    disabled: boolean;
    onSearch: () => void;
    size?: 'medium' | 'small' | 'large';
};

export const SearchButton: FunctionComponent<Props> = ({
    disabled,
    onSearch,
    size = 'medium',
}) => {
    const { formatMessage } = useSafeIntl();
    const classes: Record<string, string> = useStyles();
    return (
        <Button
            data-test="search-button"
            disabled={disabled}
            variant="contained"
            className={classes.button}
            color="primary"
            onClick={onSearch}
            size={size}
        >
            <SearchIcon className={classes.buttonIcon} />
            {formatMessage(MESSAGES.search)}
        </Button>
    );
};
